import { getRouteApi } from '@tanstack/react-router';

import { useMe } from '@/api/me';

import { useTenantUsers } from '../api/tenant-users';
import type { EmployeeRoleType } from '../schema/employee-role';
import { OutstandingRequestList } from './outstanding-request-list';
import { TenantContactList } from './tenant-contacts-list';
import { TenantEmployeeList } from './tenant-employee-list';

const route = getRouteApi('/_authenticated/_sidebar-layout/tenant/$tenantId/users');

export const TenantUsersSection = () => {
  const { tenantId } = route.useParams();

  const { data } = useTenantUsers({ id: tenantId });
  const { data: me } = useMe({ tenantId });
  const currentUserRole = me.tenantEmployees?.[0]?.role as EmployeeRoleType['role'] | undefined;

  if (!data) return null;

  return (
    <section className="flex flex-col gap-4 pb-12">
      <TenantEmployeeList
        employees={data.employees}
        tenantId={tenantId}
        currentUserRole={currentUserRole}
        isSuperAdmin={me.isSuperAdmin}
      />
      <TenantContactList contacts={data.contacts} tenantId={tenantId} />
      <OutstandingRequestList requests={data.tokens} tenantId={tenantId} />
    </section>
  );
};
